import React from 'react';
import { companyInfo } from '../styles/variables';
import heroBg from '../images/intro.jpeg';

const Hero = ({ onExplore }) => {
  return (
    <section id="home" style={{ position: 'relative', width: '100%', paddingTop: '88px' }}>
      {/* ── Split layout: image left, content right ── */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '70% 30%',
        minHeight: 'calc(100vh - 88px)',
      }}>
        {/* Left: Hero Image (~50% width, ~45vh height on desktop) */}
        <div style={{
          position: 'relative',
          overflow: 'hidden',
          minHeight: '45vh',
        }}>
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${heroBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            animation: 'heroBgZoom 10s ease-out forwards',
          }} />
          {/* subtle dark overlay for depth */}
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(160deg, rgba(10,10,10,0.35) 0%, rgba(10,10,10,0.15) 100%)',
          }} />
          {/* Gold accent bar on right edge */}
          <div style={{
            position: 'absolute',
            top: '10%', right: 0,
            width: '4px', height: '80%',
            background: 'linear-gradient(180deg, transparent, #B8965A, transparent)',
          }} />

          {/* ── Zara-style brand name: top-left of image ── */}
          <div style={{
            position: 'absolute',
            top: '2rem',
            left: '2rem',
            zIndex: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '2px',
          }}>
            <div style={{
              fontFamily: "'Cinzel', serif",
              fontSize: 'clamp(1.8rem, 3.2vw, 2.6rem)',
              fontWeight: 700,
              letterSpacing: '0.22em',
              color: '#fff',
              textTransform: 'uppercase',
              lineHeight: 1,
              textShadow: '0 1px 8px rgba(0,0,0,0.35)',
            }}>
              Swiss N Scott
            </div>
            <div style={{
              fontFamily: "'Cinzel', serif",
              fontSize: '0.72rem',
              fontWeight: 400,
              letterSpacing: '0.38em',
              color: 'rgba(255,255,255,0.75)',
              textTransform: 'uppercase',
              textShadow: '0 1px 6px rgba(0,0,0,0.3)',
            }}>
              Premium Textiles
            </div>
          </div>

          {/* Floating badge */}
          <div style={{
            position: 'absolute',
            bottom: '2rem', left: '2rem',
            background: 'rgba(255,255,255,0.12)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: '16px',
            padding: '1rem 1.5rem',
            zIndex: 2,
          }}>
            <div style={{
              fontFamily: "'Cinzel', serif",
              fontSize: '0.55rem',
              letterSpacing: '0.2em',
              color: '#D4AF7A',
              textTransform: 'uppercase',
              marginBottom: '0.3rem',
            }}>Est.</div>
            <div style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '1.6rem',
              fontWeight: 600,
              color: '#fff',
              lineHeight: 1,
            }}>2004</div>
          </div>
        </div>

        {/* Right: Hero Content */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: 'clamp(2.5rem, 5vw, 5rem) clamp(2rem, 5vw, 5rem)',
          background: 'var(--color-cream, #FAF8F5)',
          position: 'relative',
        }}>
          {/* Subtle texture */}
          <div style={{
            position: 'absolute',
            inset: 0,
            opacity: 0.025,
            backgroundImage: 'repeating-linear-gradient(45deg, #B8965A 0, #B8965A 1px, transparent 0, transparent 50%), repeating-linear-gradient(-45deg, #B8965A 0, #B8965A 1px, transparent 0, transparent 50%)',
            backgroundSize: '28px 28px',
            pointerEvents: 'none',
          }} />

          <div style={{ position: 'relative', zIndex: 1, animation: 'heroFadeUp 0.9s ease forwards' }}>
            {/* Eyebrow */}
            <div style={{
              fontFamily: "'Cinzel', serif",
              fontSize: '0.65rem',
              fontWeight: 500,
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              color: '#B8965A',
              marginBottom: '1.5rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
            }}>
              <span style={{ display: 'block', width: '32px', height: '1px', background: '#B8965A', opacity: 0.6 }} />
              Multan, Pakistan · Since {companyInfo.established}
            </div>

            {/* Title */}
            <h1 style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 'clamp(2.6rem, 4.5vw, 4.2rem)',
              fontWeight: 400,
              color: '#2C2C2C',
              lineHeight: 1.12,
              letterSpacing: '-0.01em',
              marginBottom: '1.25rem',
            }}>
              Premium Kitchen<br />
              Towels &amp;{' '}
              <em style={{ fontStyle: 'italic', color: '#B8965A', fontWeight: 400 }}>Home Textiles</em>
            </h1>

            {/* Divider */}
            <div style={{
              width: '60px',
              height: '2px',
              background: 'linear-gradient(90deg, #B8965A, transparent)',
              marginBottom: '1.5rem',
            }} />

            {/* Tagline */}
            <p style={{
              fontFamily: "'Jost', sans-serif",
              fontSize: 'clamp(0.9rem, 1.5vw, 1.05rem)',
              fontWeight: 300,
              color: '#6B6B6B',
              letterSpacing: '0.04em',
              marginBottom: '2rem',
              lineHeight: 1.8,
              maxWidth: '420px',
            }}>
              Crafted with precision. Exported with pride to international markets.
            </p>

            {/* Certification badges */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '0.5rem',
              marginBottom: '2.5rem',
            }}>
              {companyInfo.certifications.map((cert) => (
                <span key={cert} style={{
                  fontFamily: "'Cinzel', serif",
                  fontSize: '0.6rem',
                  fontWeight: 500,
                  letterSpacing: '0.1em',
                  color: '#8B6E3A',
                  border: '1px solid rgba(184,150,90,0.4)',
                  padding: '0.3rem 0.85rem',
                  borderRadius: '999px',
                  background: 'rgba(184,150,90,0.07)',
                }}>
                  {cert}
                </span>
              ))}
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <button
                onClick={onExplore}
                style={{
                  fontFamily: "'Jost', sans-serif",
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#fff',
                  background: '#B8965A',
                  padding: '0.9rem 2.25rem',
                  borderRadius: '999px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background 0.2s, transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#8B6E3A'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(184,150,90,0.35)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#B8965A'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                Explore Collections
              </button>

              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                style={{
                  fontFamily: "'Jost', sans-serif",
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#2C2C2C',
                  background: 'transparent',
                  padding: '0.9rem 2.25rem',
                  borderRadius: '999px',
                  border: '1.5px solid rgba(44,44,44,0.3)',
                  cursor: 'pointer',
                  transition: 'border-color 0.2s, background 0.2s, transform 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#B8965A'; e.currentTarget.style.color = '#B8965A'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(44,44,44,0.3)'; e.currentTarget.style.color = '#2C2C2C'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                Request a Quote
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Keyframe styles */}
      <style>{`
        @keyframes heroBgZoom {
          from { transform: scale(1.06); }
          to   { transform: scale(1); }
        }
        @keyframes heroFadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 768px) {
          #home > div {
            grid-template-columns: 1fr !important;
          }
          #home > div > div:first-child {
            min-height: 45vh !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;